// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import gql from 'graphql-tag'

const RATES_QUERY = /*#__PURE__*/ gql`
  query searchRates($args: RateInput, $published: Boolean) {
    searchRates(args: $args, published: $published) {
      value
    }
  }`

export {RATES_QUERY}
